export function useCapacityDatabaseData({
  capacitySlug,
  subscription,
}: {
  capacitySlug: string
  subscription: string
}) {
  const isAuthorized = ref(false)
  const data = ref([])
  const regions = ref([])
  const loading = ref(true)

  const { $capacityDatabase } = useNuxtApp()
  const { hasMembership } = useAuthorization()

  const fetchChartData = async (slug: string) => {
    try {
      data.value = await $capacityDatabase.getRecordsByProduct(slug)
      data.value.sort((a, b) => a.company.localeCompare(b.company))
      regions.value = await $capacityDatabase.getRegionsByProduct(slug)
    } catch (error) {
      logError(error)
    }
  }

  const fetchChartDataIfAuthorized = async () => {
    loading.value = true
    isAuthorized.value = await hasMembership(subscription)

    if (isAuthorized.value && !data.value.length) {
      await fetchChartData(capacitySlug)
    }
    loading.value = false
  }

  return {
    loading,
    isAuthorized,
    data,
    regions,
    fetchChartDataIfAuthorized,
  }
}
